/**
 * NowLine.tsx
 * Vertical "today / now" marker for the Machine Schedule grid (UX — M6).
 * Rendered absolutely inside the rows' relative wrapper so it spans every row.
 */

import React from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

interface NowLineProps {
  /** Left offset in pixels from the grid's left edge. */
  leftPx: number;
}

export const NowLine: React.FC<NowLineProps> = ({ leftPx }) => {
  const theme = useTheme();
  const color = theme.schedule.nowLine;
  return (
    <Box
      data-testid="now-line"
      sx={{
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: `${leftPx}px`,
        width: '2px',
        backgroundColor: color,
        zIndex: 4,
        pointerEvents: 'none',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: -3,
          left: -3,
          width: 8,
          height: 8,
          borderRadius: '50%',
          backgroundColor: color,
        }}
      />
    </Box>
  );
};
